import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'pool-demolition-and-backfilling-sydney';
const serviceId = 3
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Pool Demolition & Backfilling | ${BUSINESS_NAME}`,
        description: "Safe and efficient pool removal with full backfilling and site preparation, leaving your yard ready for turf or new landscaping.",
        keywords: "pool demolition sydney, pool removal, pool excavation, backfilling services, site preparation, landscaping preparation, residential pool removal, commercial pool removal, eco-friendly pool disposal, custom pool demolition solutions, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Pool Demolition & Backfilling',
    description: 'Safe and efficient pool removal with full backfilling and site preparation, leaving your yard ready for turf or new landscaping.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
